export { default } from './ApplePay';
